// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"379":"e508ed98","498":"e2a8bcb0","703":"f3b3b97c","787":"b55801b9"}[chunkId] + ".chunk.js";
};